module.exports = __webpack_public_path__ + "img/img-chart-01.4e82c347.png";